import React from 'react';

import PanelLoading from './PanelLoading';

const ApplicationLoading = () => <PanelLoading padding="53px 0 0 50px" />;

export default ApplicationLoading;
